import {TrainingChat} from './TrainingChat';
export default TrainingChat;
